module.exports = __webpack_public_path__ + "static/media/Sarang Plus.5a85c9f7.png";